import { Tab } from "@mui/material";
import { styled } from "@mui/system";

export const FooterStyles = {
  footerContainer: {
    backgroundColor: "#1a1a1a",
    color: "white",
    padding: "30px",
  },
  footerTop: {
    gap: "20px",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: { xs: "column", md: "row" },
  },
  logoContainer: {
    maxWidth: { xs: "100%", md: "500px" },
    textAlign: "center",
  },
  companyDescription: {
    flex: 1,
    // textAlign: { xs: "center", md: "left" },
    textAlign: { xs: "justify", md: "left" },
  },
  centerSection: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginTop: "30px",
    // padding: "0px 30px",
    padding: "0px 0px",
  },
  companyLinks: {
    flex: 1,
    textAlign: { xs: "left", sm: "left" },
  },
  contactSection: {
    flex: 1,
    textAlign: { xs: "left", sm: "left" },
    marginTop: { xs: "20px", sm: "0" },
  },
  title: {
    fontWeight: "bold",
    marginBottom: "10px",
  },
  link: {
    color: "white",
    textDecoration: "none",
    fontFamily: '"Poppins", serif',
    "&:hover": {
      // color: "#FF4500",
      // fontWeight: "bold",
      textDecorationLine: "underline",
    },
    fontSize: "0.8rem",
  },
  contactText: {
    marginTop: "5px",
  },
  socialIcons: {
    marginLeft: "10px",
    color: "white",
    "&:hover": {
      // color: "#FF4500",
      fontWeight: "bold",
    },
  },
  socialIconsTwo: {
    marginLeft: "10px",
    color: "#1e90ff",
    "&:hover": {
      color: "#FF4500",
    },
  },
  copyrightContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 5,
  },
  copyrightText: {
    color: "white",
    fontWeight: 500,
    fontFamily: '"Poppins", serif',
    fontSize: "0.8rem",
  },
};

// export const StyledTab = styled(Tab)(({ active }) => ({
//   textTransform: "none",
//   fontWeight: 500,
//   fontFamily: '"Poppins", serif',
//   fontSize: "13px", // 14px
//   color: active ? "white" : "#000",
//   background: active
//     ? "linear-gradient(93.14deg, #1E90FF, #63B8FF)"
//     : "transparent",
//   borderRadius: "30px",
//   // padding: "8px 15px",
//   padding: "8px 8px",
//   transition: "all 0.3s ease-in-out",
//   "&:hover": {
//     color: "black",
//     // fontWeight: "bold",
//     position: "relative",
//     "&::after": {
//       content: '""',
//       position: "absolute",
//       left: 0,
//       bottom: 0,
//       height: "2px",
//       width: "100%",
//       backgroundImage: "linear-gradient(93.14deg, #1E90FF, #63B8FF)",
//       transition: "all 0.3s ease-in-out",
//     },
//     "@media (max-width: 900px)": {
//       background: "#FF8C00",
//       color: "white",
//     },
//   },
//   "&.Mui-selected": { color: "white" },
// }));
export const StyledTab = styled(Tab)(({ active }) => ({
  textTransform: "none",
  fontWeight: 500,
  fontFamily: '"Poppins", serif',
  fontSize: "13px",
  color: active ? "white" : "#000",
  background: active
    ? "linear-gradient(93.14deg, #1E90FF, #63B8FF)"
    : "transparent",
  borderRadius: "30px",
  padding: "4px 10px",
  minHeight: "33px",
  height: "33px",
  // lineHeight: 1.2,
  transition: "all 0.3s ease-in-out",
  marginTop: 4,
  marginBottom: 4,

  "&:hover": {
    color: "black",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      // left: 0,
      // bottom: 4,
      left: "50%",
      bottom: 4,
      transform: "translateX(-50%)",
      height: "2.5px",
      width: "100%",
      backgroundImage: "linear-gradient(93.14deg, #1E90FF, #63B8FF)",
      transition: "all 0.3s ease-in-out",
      width: "60px",
    },
    "@media (max-width: 900px)": {
      background: "#FF8C00",
      color: "white",
    },
  },

  "&.Mui-selected": {
    color: "white",
  },
}));

export const navbarStyles = {
  appBar: {
    boxShadow: "none",
    padding: "4px 0", // reduce padding
    backgroundColor: "#fff",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    minHeight: "48px !important", // reduce toolbar height
  },
  logo: { height: 40 },
  tabsContainer: {
    display: { xs: "none", md: "flex" },
  },
  tabs: {
    padding: "1px",
    display: "flex",
    minHeight: "32px",
    alignItems: "center",
    borderRadius: "40px",
    background: "#F5F7FA",
    border: "1px solid #ECECEC",
  },
  menuButton: { display: { xs: "flex", md: "none" } },
  drawer: { display: { xs: "block", md: "none" } },
  drawerContent: {
    width: 250,
    padding: 2,
    display: "flex",
    flexDirection: "column",
  },
};

// export const navbarStyles = {
//   appBar: {
//     boxShadow: "none",
//     padding: "10px 0",
//     // background: "transparent",
//     backgroundColor: "#fff",
//   },
//   toolbar: { display: "flex", justifyContent: "space-between" },
//   logo: { height: 60 },
//   tabsContainer: { display: { xs: "none", md: "flex" }, background: "green" },
//   tabs: {
//     padding: "4px",
//     display: "flex",
//     minHeight: "48px",
//     alignItems: "center",
//     borderRadius: "40px",
//     background: "#F5F7FA",
//     border: "1px solid #ECECEC",
//   },
//   menuButton: { display: { xs: "flex", md: "none" } },
//   drawer: { display: { xs: "block", md: "none" } },
//   drawerContent: {
//     width: 250,
//     padding: 2,
//     display: "flex",
//     flexDirection: "column",
//   },
// };
